module.exports = __webpack_public_path__ + "img/middle-branch.77cb79c9.png";